import Storage from './Storage'

const setType = function (Type) {
  return Storage.set('auth_Type', Type)
}
const getType = function () {
  return Storage.get('auth_Type', {})
}
const setRoute = function (route) {
  return Storage.set('auth_route', route)
}

const getRoute = function () {
  return Storage.get('auth_route', {})
}

const isLogin = function () {
  return !!getType().id
}

const clearAuth = function () {
  setType({})
}

export default {
  setType,
  getType,
  setRoute,
  getRoute,
  isLogin,
  clearAuth,
}
